import React from 'react'
import { useSelector } from 'react-redux'
import get from 'lodash/get'
import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'
import { parse, stringify } from 'query-string'

export const createCanonicalUrl = (origin, pathname, query) => {
  const { cg, cb, r, m, sa, ck, cbl1 } = parse(query)
  const params = { cg, cb, r, m, sa, ck, cbl1 }
  return `${origin}${pathname}${
    Object.keys(params)
      .map((k) => params[k]) // instead of using Object.values
      .some((v) => !!v)
      ? `?${stringify(params)}`
      : ''
  }`
}

const Canonical = () => {
  const base = useSelector((state) =>
    get(state, ['config', 'urls', 'base'], 'https://www.blocket.se'),
  )
  const { search, pathname } = useLocation()
  const isLI = pathname.includes('/annonser/')
  if (isLI) {
    const canonicalUrl = createCanonicalUrl(base, pathname, search)
    return (
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
    )
  }
  return null
}

export default Canonical
